import { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Button, Form, SectionDivider, Text,
} from '@domain-group/suit-theme'

import { UseFormPayload } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import useCampaignSelector from '@hooks/useCampaignSelector'

import SuburbSearch from '@components/SuburbSearch'

import { GeoSuburbModel } from '@models/geoSuburb'

interface ContactAddressProps {
  contactFormPayload: UseFormPayload,
}

const ContactAddress = (props: ContactAddressProps) => {
  const [showAddress, setShowAddress] = useState(false)

  const { contactFormPayload } = props

  const {
    entityState: {
      address_line_1,
      address_line_2,
      address_postcode,
      address_region,
      address_state,
      id,
    },
    handlers,
    setEntityState,
  } = contactFormPayload

  const { agency: { geo_country_id } } = useCampaignSelector()

  const { geoStates } = useSelector(reduxState => reduxState.entities)

  return (
    <>
      {!showAddress && (
        <>
          <SectionDivider marginTop="large">Contact Address</SectionDivider>

          <Text color="bodyFontLightColor" fontSize="small" lineHeight="1.3" marginTop="medium">
            For agreements you might require a contact&apos;s physical address
          </Text>

          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={id ? faPencil : faPlus} />}
            onClick={() => setShowAddress(true)}
            size="medium"
            marginTop="medium"
          >
            {!id ? 'Add Address' : 'Edit Address'}
          </Button>
        </>
      )}

      {showAddress && (
        <>
          <Form.Field label="Address Line 1" marginTop="large">
            <input name="address_line_1" type="text" value={address_line_1} {...handlers} />
          </Form.Field>

          <Form.Field label="Address Line 2" marginTop="large">
            <input name="address_line_2" type="text" value={address_line_2} {...handlers} />
          </Form.Field>

          <Form.Field label="Suburb" marginTop="large">
            <SuburbSearch
              callbacks={{
                onChange: (value: string) => setEntityState({ address_region: value }),
                selectItem: (geoSuburb: GeoSuburbModel) => setEntityState({
                  address_postcode: geoSuburb?.post_code,
                  address_state: geoStates[geoSuburb.geo_state_id]?.code,
                }),
              }}
              requestOptions={{ geo_country_id }}
              value={address_region}
            />
          </Form.Field>

          <Form.Field label="State" marginTop="large">
            <input name="address_state" type="text" value={address_state} {...handlers} />
          </Form.Field>

          <Form.Field label="Postcode" marginTop="large">
            <input name="address_postcode" type="text" value={address_postcode} {...handlers} />
          </Form.Field>
        </>
      )}
    </>
  )
}

export default ContactAddress
